(function () {
    'use strict';

    angular.module('app').factory('notificationService', NotificationServiceFactory);

    class StackConfiguration {

        #verticalStackDirectionPosition = 'up';
        #horizontalStackDirection;
        #verticalOffset = '75';
        #horizontalOffset = '25';
        #stackDirection = 'top';

        constructor(horizontalStackDirection) {
            
            this.#horizontalStackDirection = horizontalStackDirection;
        }

        // First stack vertically, new entries on top
        get dir1() {
            return this.#verticalStackDirectionPosition;
        }

        // Then stack horizontally, new entries on the left
        get dir2() {
            return this.#horizontalStackDirection;
        }


        get firstpos1() {
            return this.#verticalOffset;
        }

        get firstpos2() {
            return this.#horizontalOffset;
        }

        get push() {
            return this.#stackDirection;
        }
    }

    // originally based on: https://github.com/jacqueslareau/angular-pnotify
    function NotificationServiceFactory() {

        // Configure styling
        $.pnotify.defaults.styling = "bootstrap3";

        const leftStack = createStack('stack-bottomleft', new StackConfiguration('left'));
        const rightStack = createStack('stack-bottomright', new StackConfiguration('right'));
                
        const service = {
            warning,
            success,
            error,
        };

        return service;

        function createNotification(stackConfig) {
            return {
                stack: stackConfig.stack,
                addclass: stackConfig.positionClass,
            };
        }

        /**
         * 
         * @param {String} stackName The name of the stack, currently this is the position of the notification stack
         * @param {String} positionClass 
         * @param {any} stack
         * @returns
         */
        function createStack(positionClass, stack) {
            return {
                stack: stack,
                positionClass: positionClass
            };
        }

        function warning(content) {
            const notification = createNotification(rightStack);
            notification.type = 'notice';
            notification.text = content;
            $.pnotify(notification);
        }

        function success(content) {
            const notification = createNotification(rightStack);
            notification.type = 'success';
            notification.text = content;
            $.pnotify(notification);
        }

        function error(content) {
            const notification = createNotification(leftStack);
            notification.type = 'error';
            notification.text = content;
            $.pnotify(notification);
        }
    }
})();
